var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #117093;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(32 184)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    className: "cls-1",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-32 -184)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    className: "cls-2",
    transform: "translate(-32 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(8.823 6.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-3",
    d: "M0,19.41V8.508C0,4.438,4.438,0,8.508,0h0l2.836,5.681L14.18,0h0c4.069,0,8.508,4.438,8.508,8.508v10.9",
    transform: "translate(0 16.133)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    "data-name": "Oval",
    className: "cls-3",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(4.177 0.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-3",
    d: "M1.418,4.739H0L0,2.365A2.66,2.66,0,0,1,2.367,0h0A2.654,2.654,0,0,1,4.729,2.362l0,2.375H3.309",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 5.61, 25.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-3",
    d: "M0,0A29.031,29.031,0,0,0,1.512,8.571",
    transform: "translate(6.05 16.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6-2",
    "data-name": "Path 6",
    className: "cls-3",
    d: "M-2.992,0A44.439,44.439,0,0,1-4,6.806",
    transform: "translate(19.377 16.637)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    "data-name": "Oval",
    className: "cls-3",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(14.177 24.194)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e1304532b16967666e7e368457d04765.svg";
export { ForwardRef as ReactComponent };